export default __webpack_public_path__ + "static/media/bjsh-logo.60da9be4.jpg";